<template>
    <v-row>
        <loader v-if="indexes.length === 0"/>
        <v-col
            v-for="index in indexes"
            :key="index.name"
            class="col-md-4 cols-sm-12">
            <MarketIndexTicker :ticker="index"/>
        </v-col>
    </v-row>
</template>

<script>
import MarketIndexTicker from './MarketIndexTicker'
import Loader from "@/components/Loader";

export default {
    components: {
        MarketIndexTicker,
        Loader
    },

    props: {
        indexes: {
            type: Array,
            default: () => []
        }
    }
}
</script>
